import { useOpsUserLabel } from '../../api/directory.ts';
import { cx } from '../../ui/cx.ts';

const EMPTY_FALLBACK = '—';

export function OpsUserRef({
  id,
  className,
  fallback,
}: {
  readonly id: string | null | undefined;
  readonly className?: string;
  readonly fallback?: string;
}): JSX.Element {
  const labelFor = useOpsUserLabel();
  if (id === null || id === undefined || id.length === 0) {
    return <span>{fallback ?? EMPTY_FALLBACK}</span>;
  }
  return (
    <span className={cx('font-mono', className)} title={id} data-ops-user-ref={id}>
      {labelFor(id)}
    </span>
  );
}
